// extracted by mini-css-extract-plugin
export default {"about":"style_about__p6Lch"};